function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { html as h } from "../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import u from "../../../packages/web-components/src/components/selector/gator/selector.gator.scss.js";
import m from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import f from "../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import { customElement as y } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as l } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import { TestableLitElement as b } from "../../../utils/components/testable-lit-element/testable-lit-element.js";
import { KEY_CONSTANTS as p } from "../../../consts/key-constants.js";
import { unsafeCSS as c } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/css-tag.js";
var v = Object.defineProperty,
  g = Object.getOwnPropertyDescriptor,
  r = function r(e, i, a, o) {
    for (var s = o > 1 ? void 0 : o ? g(i, a) : i, n = e.length - 1, d; n >= 0; n--) (d = e[n]) && (s = (o ? d(i, a, s) : d(s)) || s);
    return o && s && v(i, a, s), s;
  };
var t = /*#__PURE__*/function (_b) {
  function t() {
    var _this;
    _classCallCheck(this, t);
    _this = _callSuper(this, t, arguments), _this.type = null, _this.selected = !1, _this.disabled = !1, _this.current = !1, _this.tabindex = 0, _this.role = null;
    return _this;
  }
  _inherits(t, _b);
  return _createClass(t, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(t, "connectedCallback", this, 3)([]), this.addEventListener("keydown", this.handleKeydown), this.addEventListener("click", this.handleClick);
    }
  }, {
    key: "updated",
    value: function updated(e) {
      e.has("selected") && (this.ariaSelected = this.selected.toString()), e.has("current") && (this.ariaCurrent = this.current.toString()), e.has("disabled") && (this.ariaDisabled = this.disabled.toString());
    }
  }, {
    key: "render",
    value: function render() {
      return h(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"gator-selector gator-selector_", " ", " ", " ", "\">\n                <div class=\"gator-selector-spacer-start\"></div>\n                <div class=\"gator-selector-label\">\n                    <slot></slot>\n                </div>\n                <div class=\"gator-selector-spacer-end\"></div>\n            </div>\n        "])), this.type, this.selectedClass, this.disabledClass, this.currentClass);
    }
  }, {
    key: "selectedClass",
    get: function get() {
      return this.selected ? "gator-selector_selected" : "";
    }
  }, {
    key: "disabledClass",
    get: function get() {
      return this.disabled ? "gator-selector_disabled" : "";
    }
  }, {
    key: "currentClass",
    get: function get() {
      return this.current ? "gator-selector_current" : "";
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(e) {
      if (e.key === p.ENTER || e.key === p.SPACE) {
        e.preventDefault(), this.handleClick(e);
        return;
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$textContent;
      e.preventDefault(), e.stopPropagation(), !this.disabled && this.dispatchEvent(new CustomEvent("select", {
        bubbles: !0,
        detail: {
          value: (_this$textContent = this.textContent) === null || _this$textContent === void 0 ? void 0 : _this$textContent.trim(),
          selected: this.selected
        }
      }));
    }
  }]);
}(b);
t.styles = [c(u), c(m), c(f)];
r([l({
  type: String
})], t.prototype, "type", 2);
r([l({
  type: Boolean
})], t.prototype, "selected", 2);
r([l({
  type: Boolean
})], t.prototype, "disabled", 2);
r([l({
  type: Boolean
})], t.prototype, "current", 2);
r([l({
  type: Number
})], t.prototype, "tabindex", 2);
r([l({
  type: String
})], t.prototype, "role", 2);
t = r([y("ngc-selector")], t);
export { t as NgcSelector };